import * as React from 'react';
import './MapStationInfo.scss';
import { roundAndPad } from '@shared/utils/utils';


export class MapStationInfo extends React.Component<{
    stationInfo: StationCoords
}> {
    render() {
        const measure = this.props.stationInfo;
        const a = measure?.hasOwnProperty('a') ? roundAndPad(measure?.a, 2) : 0;
        const b = measure?.hasOwnProperty('b') ? roundAndPad(measure?.b, 2) : null;
        const height = measure?.elevation ? roundAndPad(measure?.elevation, 2) : null;
        const unit = kuura.getUnit().abbr;

        return (
            <>
                {measure?.stationEquation == null ? (
                    <div>
                        <span className='station-info-label'>{kuura.getMessage('tablet.station_js')}:</span>{' '}
                        <strong>{measure ? roundAndPad(measure?.station, 2) + ' ' + unit : ''}</strong>
                    </div>
                ) : (
                    <div>
                        <span className='station-info-label'>{__('tablet.stationequation_js')}:</span> <strong>{measure?.stationEquation}</strong>
                    </div>
                )}
                <div>
                    <span className='station-info-label'>{kuura.getMessage('tablet.sidemeasure_js')}:</span> <strong>{b != null ? b + ' ' + unit : ''}</strong>
                </div>
                {a != null && a != 0 ? (
                    <div>
                        <span className='station-info-label'>a:</span> <strong>{a}</strong>
                    </div>
                ) : null}
                {height != null && height != '0' ? (
                    <div>
                        <span className='station-info-label'>{kuura.getMessage('js_logpoints.height')}:</span> <strong>{height + ' ' + unit}</strong>
                    </div>
                ) : null}
            </>
        );
    }
}
